import editIcon from "@volumental/assets/icons/EditPenIcon.svg";
import deleteIcon from "@volumental/assets/icons/TrashBinIcon.svg";
import { BoxContainer, IconButton } from "@volumental/common";
import type { LabeledValue } from "@volumental/common";
import type { JSX } from "react";
import { useTranslation } from "react-i18next";
import type { SizeLocale } from "../../../api/gql/graphql";
import type { ResultStep } from "../../../store/survey";

export interface SelectedSize {
  size: LabeledValue<number>;
  locale: SizeLocale;
  width?: LabeledValue<number | undefined>;
}

const makeSizeString = (size: SelectedSize | undefined): string | undefined => {
  if (!size) {
    return undefined;
  }
  if (!size.width?.value) {
    return `${size.locale} ${size.size.label}`;
  }
  return `${size.locale} ${size.size.label} ${size.width.label}`;
};

interface ResultBoxProps {
  survey: ResultStep;
  onRemove?: () => void;
  onEdit?: () => void;
}
export function ResultBox({
  survey: { brand, gender, length, locale, width },
  onRemove,
  onEdit,
}: ResultBoxProps): JSX.Element {
  const { t } = useTranslation();
  return (
    <BoxContainer applyBorder backgroundColor="white">
      <div className="flex flex-row items-center justify-between w-full">
        <div className="flex flex-col font-normal text-base leading-6.25">
          <span className="font-bold">{brand.label}</span>
          <span>{gender.label}</span>
          <span>{makeSizeString({ size: length, locale, width })}</span>
        </div>
        <div className="flex flex-row items-center justify-center gap-4 my-1.25 ml-4">
          {onEdit !== undefined && <IconButton onClick={onEdit} iconSrc={editIcon} altText={t("imageAlt.editPP")} />}
          {onRemove !== undefined && (
            <IconButton onClick={onRemove} iconSrc={deleteIcon} altText={t("imageAlt.removePP")} />
          )}
        </div>
      </div>
    </BoxContainer>
  );
}
